//import ismagReducer from "../../modules/ismagquery/store/reducer"
//import { disclaimerReducer } from "../disclaimer/reducer"
// import filestoreListReducer from "../../modules/filestores/store/reducer"
// import profileReducer from "../../modules/profile/reducer"
// import settingReducer from "../../modules/settings/reducer"

import { OptionCl } from "../../../components/select-cl"

export type IsmagCountry = {
    ctryIsoCode: string,
    ctryName: string    
}


export type IsmagCriteriaState = {
    loading: boolean,
    error?: string,
    countries?: OptionCl[] 
}


export  type IsmagCriteriaAction =
    | {
        type: "IsmagCriteria/COUNTRIESLOADED",
        payload: any 
    } | {
        type: "IsmagCriteria/FETCHERROR",
        payload: string 
    }
  
    const initialState: IsmagCriteriaState = { loading: true }

 


export    const ismagCriteriaReducer = (
        state: IsmagCriteriaState = initialState,
        action: IsmagCriteriaAction 
    ) => {
        //console.log("in Ismag Criteria Reducer" + JSON.stringify(state) + " tms:" + Date.now())
        switch (action.type) {
            case "IsmagCriteria/COUNTRIESLOADED":
                return { ...state,  loading: false, countries: action.payload }
            case "IsmagCriteria/FETCHERROR" :    
                return {
                    ...state,
                    loading: true,
                    error: action.payload,
                  }
            default: return state
        }
    }
    